<template>
  <b-modal
    v-model="visible"
    centered
    :title="$t('people_create_draft')"
    :ok-title="$t('people_create')"
    :cancel-title="$t('cancel')"
    @ok="confirm"
    @hidden="cancel"
  >
    <b-form-group
      :label="$t('people_draft_name')"
      label-for="people-draft-name"
      :invalid-feedback="$t('people_draft_name_required')"
    >
      <b-form-input
        id="people-draft-name"
        v-model="name"
        autofocus
        :state="nameState"
        :placeholder="$t('people_name_placeholder')"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      name: '',
      validated: false,
      resolver: null,
    }
  },
  computed: {
    nameState() {
      return this.validated ? Boolean(this.name.trim()) : null
    },
  },
  methods: {
    open() {
      this.name = ''
      this.validated = false
      this.visible = true
      return new Promise(resolve => { this.resolver = resolve })
    },
    confirm(event) {
      this.validated = true
      const name = this.name.trim()
      if (!name) {
        event.preventDefault()
        return
      }
      const resolve = this.resolver
      this.resolver = null
      resolve?.(name)
    },
    cancel() {
      const resolve = this.resolver
      this.resolver = null
      resolve?.(null)
    },
  },
}
</script>
